
import Modal from './modal';

function modal(props) {
  return new Modal(props);
}

export default modal;



//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/modal/index.js
// module id = 558
// module chunks = 9